module.exports = __webpack_public_path__ + "static/keyboard3-3403dcce0ce421cdfb8f5c71701ecf0e.jpg";